<ion-header class="ion-no-border">
  <ion-toolbar [hideBackButton]="true">
    <ion-title>
      Square POS Authentication
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-tap-retry *ngIf="errorOccured" (click)="saveCredentials()"></salonmonster-tap-retry>
  
  <div *ngIf="!errorOccured">
    <salonmonster-checkmark-loader [completed]="completed" style='margin-top: 30px'></salonmonster-checkmark-loader>
  
    <square-location-picker
      *ngIf="completed"
      (locationPick)="onLocationPick($event)">
    </square-location-picker>

  </div>
</ion-content>
